/**
 * @generated SignedSource<<6d69f14dfc235e3e4d6de1797779798f>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { ReaderFragment } from 'relay-runtime';
export type PagesDisplayPersistenceOption = "CARDS" | "COMPACT_LIST" | "LIST" | "%future added value";
import type { FragmentRefs } from "relay-runtime";
export type useHomeViewsUserPreferencesFragment$data = {
  readonly __typename: "UserPreferences";
  readonly homePagesDisplayView: PagesDisplayPersistenceOption;
  readonly " $fragmentType": "useHomeViewsUserPreferencesFragment";
};
export type useHomeViewsUserPreferencesFragment$key = {
  readonly " $data"?: useHomeViewsUserPreferencesFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"useHomeViewsUserPreferencesFragment">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "useHomeViewsUserPreferencesFragment",
  "selections": [
    {
      "kind": "ScalarField",
      "name": "homePagesDisplayView"
    },
    {
      "kind": "ScalarField",
      "name": "__typename"
    }
  ],
  "type": "UserPreferences"
};

(node as any).hash = "22c9279f3bfbbbd633c516d85ea10c25";

export default node;
